import { envVars } from '@constants';
import { Api as BaseApi } from '@dotone/react-ui-core';

const Api = new BaseApi(envVars.apiV2BaseUrl);

export default Api;
